module.exports = __webpack_public_path__ + "static/media/managers-smart.55ffeb7e.svg";